import { Maybe } from './util';

export interface IFileUseType {
  name: string;
  fileUseTypeId: number;
  entityType: Maybe<number | string>;
  fileType: Maybe<number | string>;
  isEdited: boolean;
  allowMultiples: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileUseTypeFactory = {
  getDefault(fileTypeId?: string | number): IFileUseType {
    return {
      name: '',
      fileUseTypeId: 0,
      entityType: null,
      fileType: fileTypeId ?? 1,
      isEdited: false,
      allowMultiples: true,
    };
  },
};
